const IOS_REGEX = /(iPhone|iPod|iPad)/i;

///////////////////////////////////////////////////
////// PUBLIC

export function isMacOS(): boolean {
  return checkForString('mac') && !isMobileDevice();
}

export function isWindows(): boolean {
  return checkForString('windows') && !isMobileDevice();
}

export function isIOS(): boolean {
  return (
    IOS_REGEX.test(navigator.platform) || IOS_REGEX.test(navigator.userAgent)
  );
}

export function isAndroid(): boolean {
  return navigator.userAgent.toLowerCase().indexOf('android') > -1;
}

///////////////////////////////////////////////////
////// PRIVATE

function checkForString(value: string): boolean {
  return (
    navigator.platform.toLowerCase().indexOf(value) > -1 ||
    navigator.userAgent.toLowerCase().indexOf(value) > -1
  );
}

function isMobileDevice() {
  return (
    typeof window.orientation !== 'undefined' ||
    navigator.userAgent.indexOf('IEMobile') !== -1
  );
}
